import { useState, useEffect, useCallback } from "react";
import { getAgentDetailsByAgentId, getAgentsByGroupId, getAllAgents } from "../api/userApi";
import { useUser } from "../context/userContext";
import handleAgentName from "../utils/userUtils";

export function UseFetchAgentGroupData(userId) {
    // const [agentNameOptions, setAgentNameOptions] = useState([]);
    // const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     if (!groupId) {
    //         return;
    //     }

    //     const fetchData = async () => {
    //         setLoading(true);

    //         try {
    //             const response = await getAgentsByGroupId(groupId);
    //             if (response.status === 200) {
    //                 const formattedOptions = response.data.map(agent => ({
    //                     value: agent.userId,
    //                     label: handleAgentName(agent.firstName, agent.lastName, agent.alias)
    //                 }));
    //                 setAgentNameOptions(formattedOptions);
    //             }
    //         }
    //         catch (error) {
    //             console.error("Error fetching agent group data", error);
    //         }
    //         finally {
    //             setLoading(false);
    //         }
    //     };
    //     fetchData();
    // }, [groupId]);

    // return agentNameOptions;
    const [agentGroup, setAgentGroup] = useState('');
    const [agentNameOptions, setAgentNameOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userId) {
            return;
        }

        const fetchData = async () => {
            setLoading(true);

            try {
                // 1. Get current agent details
                const agentDetails = await getAgentDetailsByAgentId(userId);

                if (agentDetails.status === 200) {
                    const { groupName, groupId } = agentDetails.data;
                    setAgentGroup(groupName);

                    // 2. Get all agents in that group
                    if (groupId) {
                        const agents = await getAgentsByGroupId(groupId);

                        if (agents.status === 200) {
                            // Referral-role users can only sit in the 3rd-party Referral
                            // slot — never as the Sales Agent or Co-Agent. Strip them
                            // from the picker so accountants/admins can't select one.
                            const filtered = (agents.data || []).filter(a =>
                                !(a.userRoles || []).some(ur => ur.roleName === 'Referral')
                            );
                            const formattedNameOptions = filtered.map(agent => ({
                                value: agent.userId,
                                label: handleAgentName(agent.firstName, agent.lastName, agent.alias)
                            }));

                            setAgentNameOptions(formattedNameOptions);
                        }
                    }
                }
            }
            catch (error) {
                console.error("Error fetching agent group data", error);
            }
            finally {
                setLoading(false);
            }
        };
        fetchData();

    }, [userId]);
    return { agentGroup, agentNameOptions, loading };
}

export function UseFetchDownlineAgents(shouldFetch = true) {
    const { user } = useUser();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(shouldFetch);
    const [error, setError] = useState(null);

    const fetchDownlineAgents = useCallback(async (signal) => {
        if (!shouldFetch) {
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const response = await getAllAgents({ signal });
            const agentArray = Array.isArray(response)
                ? response
                : (
                    response && Array.isArray(response.data)
                        ? response.data
                        : []
                );
            const filteredAgent = agentArray.filter(agent => String(agent.uplineId) === String(user.userId));
            setData(filteredAgent);
        }
        catch (err) {
            if (err.name !== "AbortError") {
                setError(err);
            }
        }
        finally {
            setLoading(false);
        }
    }, [shouldFetch, user.userId]);

    // call once on mount, with an AbortController
    useEffect(() => {
        if (!shouldFetch) {
            setLoading(false);
            return;
        }
        const ac = new AbortController();
        fetchDownlineAgents(ac.signal);
        return () => ac.abort();
    }, [fetchDownlineAgents, shouldFetch]);

    // refresh exposed to consumers
    const refresh = useCallback(() => {
        if (shouldFetch) {
            fetchDownlineAgents();
        }
    }, [fetchDownlineAgents, shouldFetch]);

    return { data, loading, error, refresh };
}

export function UseFetchGroupAgents(shouldFetch = true) {
    const { user } = useUser();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(shouldFetch);
    const [error, setError] = useState(null);

    // memoized fetch — accepts an optional AbortSignal
    const fetchGroupAgents = useCallback(async (signal) => {
        if (!shouldFetch) {
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const agentDetails = await getAgentDetailsByAgentId(user.userId, { signal });
            const response = await getAgentsByGroupId(agentDetails.data.groupId, { signal });
            const agentArray = Array.isArray(response)
                ? response
                : (
                    response && Array.isArray(response.data)
                        ? response.data
                        : []
                );
            setData(agentArray);
        }
        catch (err) {
            if (err.name !== "AbortError") {
                setError(err);
            }
        }
        finally {
            setLoading(false);
        }
    }, [shouldFetch, user.userId]);

    // call once on mount, with an AbortController
    useEffect(() => {
        if (!shouldFetch) {
            setLoading(false);
            return;
        }
        const ac = new AbortController();
        fetchGroupAgents(ac.signal);
        return () => ac.abort();
    }, [fetchGroupAgents, shouldFetch]);

    // refresh exposed to consumers
    const refresh = useCallback(() => {
        if (shouldFetch) {
            fetchGroupAgents();
        }
    }, [fetchGroupAgents, shouldFetch]);

    return { data, loading, error, refresh };
}